
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";


/* ======================================== */
/* 1.  KPI SUMMARY CARDS (B2C)              */
/* ======================================== */
export const KpiSummaryCards = () => {
  const stats = [
    { label: "Active Users", value: 23892 },
    { label: "Emails Sent", value: 76312 },
    { label: "New Leads", value: 4189 },
    { label: "Revenue", value: "₹12.3 L" },
  ];
  const bg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");
  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} gap={6}>
      {stats.map((s) => (
        <Stat
          key={s.label}
          p={4}
          bg={bg}
          rounded="xl"
          border="1px"
          borderColor={border}
          shadow="sm"
        >
          <StatLabel>{s.label}</StatLabel>
          <StatNumber>{typeof s.value === "number" ? s.value.toLocaleString() : s.value}</StatNumber>
        </Stat>
      ))}
    </SimpleGrid>
  );
};